export default __webpack_public_path__ + "static/media/setReadingGoal.d4d47e98.png";